<template>
  <div class="feature-2">
    <div class="field-icon">
      <img :src="feature.image" alt="">
    </div>
    <div class="field-box-title heading-3-bold" v-html="feature.title"></div>
    <div class="field-box-title paragraph-1-large" v-html="feature.subTitle"></div>
    <div class="button-container">
      <seu-button
        :label="feature.buttonLabel"
        :button-link="feature.buttonLink"
        :button-icon-before="feature.buttonIcon"
      />
    </div>
  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";

export default {
  name: 'Feature2',
  components: {SeuButton},
  props: {
    feature: {
      type: Object
    }
  },
}
</script>

<style lang="scss">
@import "Feature2";
</style>
